// extracted by mini-css-extract-plugin
export var card = "_6i-0";
export var expandedCard = "_6i-2";
export var paginated = "_6i-1";